import { useContext } from "react"
import AuthContext from "../context/AuthContext"

export function useApi() {
  const auth = useContext(AuthContext)

  async function fetcher<TResponse = unknown>(
    path: string
  ): Promise<TResponse> {
    const token = await auth?.getAccessToken()
    const response = await fetch(path, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Could not fetch")
    }
    return response.json()
  }

  async function post<TResponse>(
    path: string,
    opts?: { body: BodyInit | null | undefined }
  ): Promise<TResponse> {
    const token = await auth?.getAccessToken()

    const res = await fetch(path, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...opts,
    })
    if (!res.ok) throw new Error("Could not post")
    return res.json()
  }

  async function patch<TResponse>(
    path: string,
    opts?: { body: BodyInit | null | undefined }
  ): Promise<TResponse> {
    const token = await auth?.getAccessToken()

    const res = await fetch(path, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...opts,
    })
    if (!res.ok) throw new Error("Could not patch")
    return res.json()
  }

  const deleteCall = async (path: string) => {
    const token = await auth?.getAccessToken()

    const res = await fetch(path, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (!res.ok) throw new Error("Could not delete")
    return
  }

  return {
    get: fetcher,
    post,
    delete: deleteCall,
    patch,
  }
}
